import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import whiteLogo from '../images/whitelogo.png';

const styles = {
  section: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
  },
  container: {
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    padding: '32px',
    width: '100%',
    maxWidth: '400px',
  },
  logo: {
    height: '64px',
    width: 'auto',
    display: 'block',
    margin: '0 auto 24px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#ffffff',
    marginBottom: '24px',
  },
  errorMessage: {
    color: '#dc2626',
    textAlign: 'center',
    marginBottom: '16px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  label: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#ffffff',
  },
  input: {
    width: '100%',
    padding: '8px 0px',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
    outline: 'none',
    fontSize: '16px',
  },
  inputFocus: {
    borderColor: '#2563eb',
    boxShadow: '0 0 0 3px rgba(37, 99, 235, 0.1)',
  },
  button: {
    width: '100%',
    backgroundColor: '#2563eb',
    color: '#ffffff',
    padding: '8px 16px',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  buttonHover: {
    backgroundColor: '#1d4ed8',
  },
  externalButton: {
    width: '100%',
    backgroundColor: '#3b82f6',
    color: '#ffffff',
    padding: '8px 16px',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    marginTop: '20px',
  },
  externalButtonHover: {
    backgroundColor: '#2563eb',
  },
};

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // Regular form login (POST)
  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://interactivebot.tgnsys.ir/api/login.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (data.status === 'success') {
        localStorage.setItem('token', data.token);
        onLogin(data.token);
        navigate('/');
      } else {
        setMessage(data.message);
      }
    } catch (error) {
      setMessage('خطا در ارتباط با سرور');
      console.error('Login error:', error);
    }
  };

  // Handle tgnsys.ir login via URL parameters
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const user = searchParams.get('user');
    const password = searchParams.get('password');

    if (user && password) {
      const loginWithParams = async () => {
        try {
          const response = await fetch('https://interactivebot.tgnsys.ir/api/login.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username: user, password: password }),
          });

          const data = await response.json();

          if (data.status === 'success') {
            localStorage.setItem('token', data.token);
            onLogin(data.token);
            navigate('/');
          } else {
            setMessage(data.message);
          }
        } catch (error) {
          setMessage('خطا در ورود از tgnsys.ir');
          console.error('tgnsys login error:', error);
        }
      };

      loginWithParams();
    }
  }, [location, navigate, onLogin]);

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <img
          id="logoSignInForm"
          src={whiteLogo}
          alt="logo of site HamkarTala"
          style={styles.logo}
        />
        <h1 style={styles.title}>صفحه ورود</h1>
        {message && <p style={styles.errorMessage}>{message}</p>}
        <form onSubmit={handleLogin} style={styles.form}>
          <div>
            <label htmlFor="username" style={styles.label}>
              نام کاربری:
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="off"
              style={styles.input}
              onFocus={(e) => (e.target.style.borderColor = styles.inputFocus.borderColor)}
              onBlur={(e) => (e.target.style.borderColor = styles.input.borderColor)}
            />
          </div>
          <div>
            <label htmlFor="password" style={styles.label}>
              رمز عبور:
            </label>
            <div className="password-input-container">
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={styles.input}
                onFocus={(e) => (e.target.style.borderColor = styles.inputFocus.borderColor)}
                onBlur={(e) => (e.target.style.borderColor = styles.input.borderColor)}
              />
            </div>
          </div>
          <button
            id="login"
            type="submit"
            style={styles.button}
            onMouseOver={(e) => (e.target.style.backgroundColor = styles.buttonHover.backgroundColor)}
            onMouseOut={(e) => (e.target.style.backgroundColor = styles.button.backgroundColor)}
          >
            ورود
          </button>
        </form>
        <div>
          <button
            onClick={() =>
              (window.location.href =
                'https://tgnsys.ir/login?redirect=https://interactivebot.tgnsys.ir/login')
            }
            style={styles.externalButton}
            onMouseOver={(e) => (e.target.style.backgroundColor = styles.externalButtonHover.backgroundColor)}
            onMouseOut={(e) => (e.target.style.backgroundColor = styles.externalButton.backgroundColor)}
          >
            ورود از طریق tgnsys.ir
          </button>
        </div>
      </div>
    </section>
  );
};

export default Login;